'use client';
// import { useMaintenanceMode } from '@/contexts/MaintenanceModeContext';
import { Tooltip } from 'react-tooltip';
import { classNames } from '@/lib/utils';

type ButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & { withMaintenanceMode?: boolean; };

export function Button({
  className: classNameProp,
  disabled: disabledProp,
  withMaintenanceMode = false,
  children,
  ...props
}: ButtonProps) {
  // const isInMaintenanceMode = useMaintenanceMode() && withMaintenanceMode;
  // const disabled = isInMaintenanceMode || disabledProp;
  // const className = isInMaintenanceMode
  //   ? `${classNameProp} cursor-not-allowed `
  //   : classNameProp;

  // Remove in order to enable maintenance mode
  const isInMaintenanceMode = false;
  const disabled = disabledProp;
  const className = classNameProp;

  const buttonElement = (
    <button
      disabled={disabled}
      className={classNames(
        disabled
          ? 'cursor-not-allowed bg-yellow-300 text-black focus:ring-yellow-500'
          : 'bg-indigo-500 text-white hover:bg-indigo-600 focus:border-indigo-500 focus:ring-indigo-500',
        'z-[1] group border shadow-xs relative cursor-pointer overflow-hidden gap-2 rounded-full border-transparent px-4 py-3.5 text-[0.95rem] font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2',
        className
      )}
      {...props}
    >
      <div className="transition-all duration-300 ease-in-out rounded-full button-shine-gradient group-hover:opacity-0" />
      {children}
    </button>
  );
  if (isInMaintenanceMode) {
    const wrapperId = `${props.id}-wrapper`;
    return (
      <>
        <div id={wrapperId}>{buttonElement}</div>
        <Tooltip anchorId={wrapperId}>
          <p>The App is currently in maintenance mode. </p>
          <p>Please check back later.</p>
        </Tooltip>
      </>
    );
  }
  return buttonElement;
}
